<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <v-container class="text-center py-16">
        <v-icon color="primary" size="80" class="mb-6">mdi-dice-multiple</v-icon>
        <h1 class="text-h2 font-weight-bold mb-4">
          <span class="text-primary">Backgammon</span> Tracker
        </h1>
        <p class="text-h6 text-grey-lighten-1 mb-8" style="max-width: 600px; margin: 0 auto">
          Record your games, get AI-powered analysis, and become a better backgammon player.
        </p>
        <div class="d-flex justify-center ga-4">
          <v-btn color="primary" size="x-large" to="/register" rounded="lg">
            <v-icon start>mdi-account-plus</v-icon>
            Get started for free
          </v-btn>
          <v-btn variant="outlined" color="primary" size="x-large" to="/pricing" rounded="lg">
            See pricing
          </v-btn>
        </div>
      </v-container>
    </section>

    <!-- Features Section -->
    <v-container class="py-12">
      <h2 class="text-h4 text-center font-weight-bold mb-10">
        Everything you need
      </h2>
      <v-row>
        <v-col v-for="feature in features" :key="feature.title" cols="12" md="4">
          <v-card color="surface-variant" class="pa-6 text-center h-100" variant="flat">
            <v-icon :color="feature.color" size="48" class="mb-4">{{ feature.icon }}</v-icon>
            <h3 class="text-h6 mb-2">{{ feature.title }}</h3>
            <p class="text-body-2 text-grey-lighten-1">{{ feature.desc }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- CTA Section -->
    <section class="py-12">
      <v-container class="text-center">
        <v-card color="surface-variant" class="pa-10" variant="flat">
          <h2 class="text-h4 font-weight-bold mb-4">Ready to track your games?</h2>
          <p class="text-body-1 text-grey-lighten-1 mb-6">
            Create a free account and start improving your game today.
          </p>
          <v-btn color="primary" size="large" to="/register">
            Create free account
          </v-btn>
        </v-card>
      </v-container>
    </section>
  </div>
</template>

<script setup>
const features = [
  {
    icon: "mdi-upload",
    color: "primary",
    title: "Upload games",
    desc: "Upload your games directly from the app and keep track of all your matches.",
  },
  {
    icon: "mdi-brain",
    color: "info",
    title: "AI Analysis",
    desc: "Get in-depth AI analysis of your moves and learn from your mistakes.",
  },
  {
    icon: "mdi-chart-line",
    color: "success",
    title: "Statistics",
    desc: "See detailed statistics about your development and win/loss ratio.",
  },
  {
    icon: "mdi-account-group",
    color: "warning",
    title: "Find opponents",
    desc: "Find and challenge other players online in your area.",
  },
  {
    icon: "mdi-forum",
    color: "accent",
    title: "Forum",
    desc: "Discuss strategies and share experiences with other backgammon enthusiasts.",
  },
  {
    icon: "mdi-trophy",
    color: "error",
    title: "Tournaments",
    desc: "Participate in tournaments and compete for top rankings.",
  },
];
</script>

<style scoped>
.hero-section {
  background: linear-gradient(
    135deg,
    rgba(212, 164, 76, 0.08) 0%,
    rgba(15, 15, 26, 0) 60%
  );
  border-bottom: 1px solid rgba(212, 164, 76, 0.1);
}
</style>
